import { Progress, Typography } from 'antd';

interface ProgressPercentageCellProps {
  value?: number | null;
}

export const ProgressPercentageCell = ({
  value
}: ProgressPercentageCellProps) => {
  if (value == null) {
    return <Typography.Text>-</Typography.Text>;
  }

  const percent = Number(value);

  return (
    <Progress
      type="circle"
      percent={percent}
      size={40}
      strokeWidth={8}
      strokeColor="#7c3aed"
      status="normal"
      format={p => `${p}%`}
    />
  );
};
